export default __webpack_public_path__ + "static/media/browser1.8378af4b.png";